function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/* eslint-disable max-len */
import React from 'react';
import withCssProps from '../../../hocs/withCssProps';
import { StyledIcon } from './StyledIcon';
export var IsliderArrowRight = withCssProps(function (props) {
  return /*#__PURE__*/React.createElement(StyledIcon, _extends({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.28857 17.8725L13.9586 12.2925L8.37857 6.7025C7.98857 6.3125 7.98857 5.6825 8.37857 5.2925C8.76857 4.9025 9.39857 4.9025 9.78857 5.2925L16.0786 11.5925C16.4686 11.9825 16.4686 12.6125 16.0786 13.0025L9.69857 19.2925C9.30857 19.6825 8.67857 19.6825 8.28857 19.2925C7.90857 18.9025 7.89857 18.2625 8.28857 17.8725Z",
    fill: "#495057"
  }));
});